import { render, staticRenderFns } from "./setTukarLantik.vue?vue&type=template&id=2eb0d426&"
import script from "./setTukarLantik.vue?vue&type=script&lang=js&"
export * from "./setTukarLantik.vue?vue&type=script&lang=js&"
import style0 from "./setTukarLantik.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports